export default "__VITE_ASSET__BPM1vI6K__"